import { useContext, useEffect } from "react";

import ProposalOutputContext from "../context/ProposalOutputContext";
import { useSSO } from "../context/AuthContext";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import ErrorModal from "../components/layout/ErrorModal";
import SuccessAlert from "../components/layout/SuccessAlert";
import Loader from "../components/layout/Loader";
import ResponsiveAppBar from "../components/layout/ResponsiveAppBar";
import OutputHeader from "../components/proposal/proposalOutput/OutputHeader";
import OutputSection from "../components/proposal/proposalOutput/OutputSection";
import OutputFooter from "../components/proposal/proposalOutput/OutputFooter";

const ProposalOutputPage = () => {
  const {
    apiRes, setApiRes, setProposalId, sectionsArray
  } = useContext(ProposalOutputContext);
  const { getSSOProtectedData } = useSSO();

  useEffect(() => {
    getSSOProtectedData();
    const docUrIArr = window.location.href.split('/');
    const uid = docUrIArr[docUrIArr.length - 1];
    if (uid) {
      setProposalId(uid);
    }
  }, []);

  return (
    <Box className="mainContainer">
      <style>
        {`
          .ql-editor {
            font-size: 18px;
          }
        `}
      </style>
      {apiRes.loading && <Loader />}
      {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}

      <ResponsiveAppBar />
      <Container maxWidth="xl">
        <Grid
          container
          spacing={2}
          sx={{ mt: 3 }}
        >
          <OutputHeader />
          <Box mb={12}>
            {sectionsArray.map((title, index) => (
              <OutputSection key={index} title={title} />
            ))}
          </Box>

          <OutputFooter />
        </Grid>
      </Container>
      <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
    </Box>
  );
};

export default ProposalOutputPage;